import * as R from 'ramda'
const streetsIdent = [
	' ave'
  , ' anx'
  , ' arc'
  , ' blvd'
  , ' cir'
  , ' ct'
  , ' dr'
  , ' expy'
  , ' ft'
  , ' fwy'
  , ' gln'
  , ' grn'
  , ' grv'
  , ' hts'
  , ' hwy'
  , ' is'
  , ' jct'
  , ' ln'
  , ' loop'
  , ' lp'
  , ' mt'
  , ' pky'
  , ' pl'
  , ' rd'
  , ' spg'
  , ' spgs'
  , ' sq'
  , ' st'
  , ' ter'
  , ' tpke'
  , ' way'
  , ' Alley'
  , ' Annex'
  , ' Arcade'
  , ' Avenue'
  , ' Bend'
  , ' Bay'
  , ' Brae'
  , ' Boulevard'
  , ' Bypass'
  , ' Circle'
  , ' Close'
  , ' Court'
  , ' Cove'
  , ' Crescent'
  , ' Drive'
  , ' Drung'
  , ' Esplanade'
  , ' Expressway'
  , ' Extension'
  , ' Ferry'
  , ' Field'
  , ' Freeway'
  , ' Garden'
  , ' Gardens'
  , ' Gate'
  , ' Glen'
  , ' Green'
  , ' Grove'
  , ' Heights'
  , ' High Street'
  , ' Highway'
  , ' Hill'
  , ' Lane'
  , ' Line'
  , ' Mall'
  , ' Manor'
  , ' Mews'
  , ' Nene'
  , ' Parade'
  , ' Park'
  , ' Parkway'
  , ' Path'
  , ' Pike'
  , ' Place'
  , ' Plantation'
  , ' Plaza'
  , ' Point'
  , ' Private'
  , ' Promenade'
  , ' Road'
  , ' Sideline'
  , ' Route'
  , ' Row'
  , ' Run'
  , ' Spur'
  , ' Square'
  , ' Stravenue'
  , ' Street'
  , ' Terrace'
  , ' Thruway'
  , ' Trace'
  , ' Trail'
  , ' Turnpike'
  , ' Townline'
  , ' Viaduct'
  , ' Walk'
  , ' Wynd'
]

export let propertyAlias = (address) => {
	if(!address.length) return ""

	let alias = address.replace(/\d/g, '').trim()

	let strIdent = R.reject((str) => !~alias.toLowerCase().indexOf(str.toLowerCase()), streetsIdent)
	let comaIdent = (!!~alias.indexOf(','))? alias.indexOf(',') + 1 : -1
	if(!strIdent.length){
		strIdent = (!!~alias.indexOf(','))? alias.indexOf(',') : -1
	}else{
		strIdent = alias.toLowerCase().indexOf(strIdent[0].toLowerCase())
	}
	if(strIdent == -1) return address
	alias = `${alias.substr(0, strIdent).trim()} ${alias.substr(comaIdent).trim().split(' ')[alias.substr(comaIdent).trim().split(' ').length - 1]}`
	return alias
}



// WEBPACK FOOTER //
// ./src/utils/propertyAlias.js